import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=1b110f61&scoped=true"
import script from "./Expandable.vue?vue&type=script&setup=true&lang=js"
export * from "./Expandable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Expandable.vue?vue&type=style&index=0&id=1b110f61&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b110f61",
  null
  
)

export default component.exports